import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklinePayment } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getVehicleLedgerData
} from "../../../store/actions/vehicleActionCreator";
import {
    getTransactionHistory,
    getSinglePayment,
    getPaymentStatus
} from "../../../store/actions/OnlinePaymentActionCreators";
import {
    getFastTagRechargeStatus, getSingleFastTagDetails
} from "../../../store/actions/fastagActionCreators";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles, fade } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, findArrayObject } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing-online-payments';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import TopCard from '../../components/TopCard/TopCard';
import TopCardIcon from '../../components/TopCard/TopCardIcon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { InputBase } from '@material-ui/core';
import {
    PayDriver,
    PayShop,
    PaySupplier,
    PaymentRecieved,
    PaymentFastag,
    PaymentWallet,
    TransactionHistory,
    TransactionPending,
    PaySupplierBorder
} from '../../components/TopCard/icons';
import { trackDwebEvent } from '../../analytics';
import TransactionDetailsSideBar from '../../components/RightSideBar/TransactionDetailsSideBar';
import PaymentDetailsCard from '../../components/Payment/PaymentDetailsCard';
import SingleOnlineTransactionDetailsCard from '../../components/Payment/SingleOnlineTransactionDetailsCard'
import DottedDivider from '../../components/Divider/DottedDivider';
import TripListingCard from '../../components/listing/TripListingCard';
import PayDriverSideBar from '../../components/RightSideBar/PayDriverSideBar';
import queryString from "query-string";
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import PaySupplierSideBar from '../../components/RightSideBar/PaySupplierSideBar';
import Highlighter from "react-highlight-words";
import PartyPaymentIcon from '../../../assets/party_payment.svg';
import PayShopIcon from '../../../assets/pay_shop.svg';
import PaySupplierIcon from '../../../assets/pay_supplier_icon.svg';
import PayDriverIcon from '../../../assets/pay_driver.svg';
import FuelRechargeIcon from '../../../assets/fuel_recharge.png';
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, onlinePaymentsTableHeight, defaultDebounceMs, onlinePaymentsTableHeightWithoutTopCards } from '../../../paginationVariables';
import { Waypoint } from "react-waypoint";
import PayShopSideBar from '../../components/RightSideBar/PayShopSideBar';
import OnlinePaymentsPopUp from '../../components/Dialog/OnlinePaymentsPopUp';

import FastTagTransactDetailsSideBar from '../../components/FastTagDialogAndSidebar/FastTagTransactDetailsSideBar';
// import RechargeFastagSideBar from '../../components/RightSideBar/RechargeFastagSideBar';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import DateFilter from '../../components/FilterComponent/DateFilter';
import PaymentStatusFIlter from '../../components/FilterComponent/PaymentStatusFIlter';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import TransactionReportDialog from '../../components/ReportsDialog/TransactionReportDialog';
import moment from 'moment';
import { getTripStartDateFilterValues } from '../../../utils/utils';
import CustomDateFilterDialog from '../../components/FilterComponent/CustomDateFilter';
import DieselCardIcon from '../../../assets/diesel-card-icon.png';
import { GetPaymentStatusIconOnly, GetPaymentModes } from '../../components/Payment/GetPaymentStatusIcon';
const OnlinePayments = ({
    user,
    vehicle,
    dispatchGetPaymentDetails,
    dispatchTransactionHistoryAction,
    dispatchGetPaymentStatus,
    dispatchGetFastTagRechargeStatus,
    dispatchGetSingleFastTagDetails,
    location
}) => {
    const classes = useStyles();
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    const [transactionHistoryData, setTransactionHistoryData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [open, setOpen] = useState(false);
    const [initialEmpty, setInitialEmpty] = useState(false);
    const [driverPaymentOpen, setDriverPaymentOpen] = useState(false);
    const [shopPaymentOpen, setShopPaymentOpen] = useState(false);
    const [secondaryTitle, setSecondaryTitle] = useState("")
    const [transactionData, setTransactionData] = useState({})
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [defaultData, setDefaultData] = useState(null)
    const [supplierPaymentOpen, setSupplierPaymentOpen] = useState(false);
    const [configInfo, setConfigInfo] = useState({});
    const [fuelCardConfig, setFuelCardConfig] = useState({})
    const [payOutData, setPayOutData] = useState({});
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [onlinePaymentPopUpOpen, setOnlinePaymentPopUpOpen] = useState(false);
    const [fastTagTransactDetailsOpen, setFastTagTransactDetailsOpen] = useState(false)
    const [rechargeFastagOpen, setRechargeFastagOpen] = useState(false);
    const [recall, setRecall] = useState(false);
    const [loadingText, setLoadingText] = useState("Sorry, no data found");

    const [selectedFilterStatus, setSelectedFilterStatus] = useState("all");
    const [selectedFilterDate, setSelectedFilterDate] = useState("ALL_MONTHS");
    const [changeFlag, setChangeFlag] = useState(false);
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({})
    const [transactionReportOpen, setTransactionReportOpen] = useState(false);

    var filterStatus = {};

    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setSelectedFilterDate(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setSelectedFilterDate("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    const handlePaymentStatusValue = (value) => {
        setSelectedFilterStatus(value);
        setChangeFlag(true);
    }
    useEffect(() => {
        trackDwebEvent('Dweb Online Payments page', {});
    }, []);

    const goToOnlinePayments = () => {
        history.push({
            pathname: `/online-payments`,
            state: {
                id: 1,
                pageTitle: 'Online Payments'
            }
        });
    }
    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = () => {
        setSuccessCreation(false)
        goToOnlinePayments()
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = () => {
        setFailureCreation(false)
        goToOnlinePayments()
    }
    const paymentReqData = {
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        searchText: searchText,
    };
    const getPaginatedData = () => {

        const paymentPaginatedReqData = {
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge: true,
            type: selectedFilterStatus,
            ...getDateRangeValue()
        };


        dispatchTransactionHistoryAction(paymentPaginatedReqData, () => {

        })
    }
    const onSearchBlur = debounce(query => {
        setLoadingText("Loading........");
        setTransactionHistoryData([]);
        setCurrentPageNo(defaultPageNo)
        dispatchTransactionHistoryAction({ ...paymentReqData, ...getDateRangeValue(), type: selectedFilterStatus, searchText: query },
            () => {
                setLoadingText("Sorry, no data found");
            },
            () => {
                setLoadingText("Sorry, no data found");
            }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    let dateFilterValues = getTripStartDateFilterValues();
    const getDateRangeValue = () => {
        let date = {
            startDateEpoch: dateFilterValues[selectedFilterDate]["startDateRange"]["startTimeEpoch"],
            endDateEpoch: dateFilterValues[selectedFilterDate]["startDateRange"]["endTimeEpoch"]
        };
        if (customFilterValue && customFilterValue.startTimeEpoch) {
            date = {
                startDateEpoch: customFilterValue["startTimeEpoch"],
                endDateEpoch: customFilterValue["endTimeEpoch"]
            }
        }
        return date
    }
    useEffect(() => {
        setCurrentPageNo(defaultPageNo);
        setTransactionHistoryData([]);
        setLoadingText("Loading........");
        if (changeFlag) {
            dispatchTransactionHistoryAction({
                ...paymentReqData,
                ...getDateRangeValue(),
                type: selectedFilterStatus
            },
                () => {
                    setLoadingText("Sorry, no data found");
                },
                () => {
                    setLoadingText("Sorry, no data found");
                }
            )
        }
    }, [selectedFilterStatus, selectedFilterDate, customFilterValue]);
    useEffect(() => {

        if (user && user.configs && (user.configs.online_payments_config || user.configs.fuel_card)) {
            setConfigInfo(user.configs.online_payments_config);
            setFuelCardConfig(user.configs.fuel_card)
        } else {
            setConfigInfo({});
            setFuelCardConfig({})
        }

    }, [user.configs]);


    useEffect(() => {
        dispatchTransactionHistoryAction(paymentReqData, (data) => {
            if (data && data.status && data.status.code == 200 && data.response && data.response.totalCount == 0) {
                setInitialEmpty(true)
            }
            if (orderId) {
                dispatchGetPaymentStatus({
                    orderId: orderId
                }, (response) => {
                    if (response && response.status && response.status.code == 200) {
                        if (response.response.message == "Transaction Failed.") {
                            handleFailureOpen()
                            setTimeout(() => {
                                handleFailureClose()
                            }, 3000);
                        } else {

                            if (payOutData && payOutData.driverId) {
                                trackDwebEvent('Dweb Driver payout successful', {
                                    driver_id: payOutData && payOutData.id ? payOutData.id : "",
                                    driver_name: payOutData && payOutData.name ? payOutData.name : "",
                                    driver_balance: payOutData && payOutData.driverBalance ? payOutData.driverBalance : "",
                                    driver_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                                    driver_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                                    bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                                });
                            }
                            if (payOutData && payOutData.shopId) {
                                trackDwebEvent('Dweb shop payout successful', {
                                    shop_id: payOutData && payOutData.id ? payOutData.id : "",
                                    shop_name: payOutData && payOutData.name ? payOutData.name : "",
                                    shop_balance: payOutData && payOutData.balance ? payOutData.balance : "",
                                    shop_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                                    shop_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                                    bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                                });
                            }
                            handleSuccessOpen()
                            setTimeout(() => {
                                handleSuccessClose()
                            }, 3000);
                        }
                    } else {
                        if (payOutData && payOutData.driverId) {
                            trackDwebEvent('Dweb Driver payout failed', {
                                driver_id: payOutData && payOutData.id ? payOutData.id : "",
                                driver_name: payOutData && payOutData.name ? payOutData.name : "",
                                driver_balance: payOutData && payOutData.driverBalance ? payOutData.driverBalance : "",
                                driver_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                                driver_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                                bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                            });
                            if (payOutData && payOutData.shopId) {
                                trackDwebEvent('Dweb shop payout failed', {
                                    shop_id: payOutData && payOutData.id ? payOutData.id : "",
                                    shop_name: payOutData && payOutData.name ? payOutData.name : "",
                                    shop_balance: payOutData && payOutData.balance ? payOutData.balance : "",
                                    shop_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                                    shop_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                                    bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                                });
                            }
                        }
                        handleFailureOpen()
                        setTimeout(() => {
                            handleFailureClose()
                        }, 3000);
                    }
                }, () => {
                    if (payOutData && payOutData.driverId) {
                        trackDwebEvent('Dweb Driver payout failed', {
                            driver_id: payOutData && payOutData.id ? payOutData.id : "",
                            driver_name: payOutData && payOutData.name ? payOutData.name : "",
                            driver_balance: payOutData && payOutData.driverBalance ? payOutData.driverBalance : "",
                            driver_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                            driver_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                            bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                        });
                    }
                    if (payOutData && payOutData.shopId) {
                        trackDwebEvent('Dweb shop payout failed', {
                            shop_id: payOutData && payOutData.id ? payOutData.id : "",
                            shop_name: payOutData && payOutData.name ? payOutData.name : "",
                            shop_balance: payOutData && payOutData.balance ? payOutData.balance : "",
                            shop_payout_amount: payOutData && payOutData.amount ? payOutData.amount : "",
                            shop_payout_reason: payOutData && payOutData.reason ? payOutData.reason : "",
                            bank_account_id: payOutData && payOutData.bankAccountId ? payOutData.bankAccountId : ""
                        });
                    }
                    handleFailureOpen();
                    setTimeout(() => {
                        handleFailureClose()
                    }, 3000);
                })
            }
        });
    }, [
        recall
    ]);
    useEffect(() => {
        if (user && user.allTransactionHistory) {
            if (user.allTransactionHistory.transactions) {
                setTransactionHistoryData(user.allTransactionHistory.transactions);
            }
        }
    }, [user.allTransactionHistory]);

    useEffect(() => {

        const checkPopUp = localStorage.getItem('OnlinePaymentsPopUpShown');
        if (!checkPopUp) {
            setOnlinePaymentPopUpOpen(true);
        }

    }, []);

    const handleClose = () => {
        // dispatchTransactionHistoryAction(paymentReqData, () => {

        // });
        setOpen(false)
    }
    const handlePayDriverOpen = () => {
        setDriverPaymentOpen(true)
    }
    const handlePayShopOpen = () => {
        setShopPaymentOpen(true)
    }
    const handlePayDriverClose = (entityData) => {
        dispatchTransactionHistoryAction(paymentReqData, () => {

        });
        setDefaultData(null);
        setDriverPaymentOpen(false);
        setPayOutData(entityData);
    }

    const handlePayShopClose = (entityData) => {
        dispatchTransactionHistoryAction(paymentReqData, () => {

        });
        setDefaultData(null);
        setShopPaymentOpen(false);
        setPayOutData(entityData);
    }


    const handlePaySupplierOpen = () => {
        setSupplierPaymentOpen(true);
    }
    const handlePaySupplierClose = () => {
        dispatchTransactionHistoryAction(paymentReqData, () => {

        });
        setSupplierPaymentOpen(false);
    }

    const getSubTitle = (type) => {
        switch (type) {
            case "vendor":
                return "Supplier Payment";
            case "shop":
                return "Shop Payment";
            case "driver":
                return "Driver Payment";
            case "customer":
                return "Party Payment";
            case "fastag":
                return "Fastag Recharge";
            case "wallet":
                return "Wallet Topup";
            case "fuelcard":
                return "Fuel Recharge";
            default:
                return null
        }
    }
    const handleTransactionRow = (index) => {
        if (index == 0 || index) {
            let req = {}
            let data = transactionHistoryData[index];
            let type = data && data.entityType ? data.entityType : null;

            if (type && (data.entityId || data.transactionId) && type != 'fastag') {
                req.id = data.entityId ? data.entityId : data.transactionId ? data.transactionId : ''
                setSecondaryTitle(getSubTitle(type))
                dispatchGetPaymentDetails(
                    data,
                    (response) => {
                        if (response && response.status && response.status.code == 200 && response.response) {
                            response.response.entityType = type;
                            setTransactionData(response.response);
                            setOpen(true);
                        }
                    },
                    (response) => {

                    }
                )
            } else {

                dispatchGetFastTagRechargeStatus(data && data.transactionId ? data.transactionId : "",
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('Online Payments Listing Dweb', 'Get Fast Tag Recharge Status Successfull');
                            setFastTagTransactDetailsOpen(true);
                            setTransactionData(data.response);
                            //setOpen(true)
                        }
                    },
                    () => {
                        logger.log('Online Payments Listing Dweb', 'Get Fast Tag Recharge Status Failed');
                    }
                )

            }
        }
    }
    const getTypesIcons = (type) => {
        switch (type) {
            case "vendor":
                return <img src={PaySupplierIcon} />
            //return <PaySupplier className={classes.listIcon} />
            case "shop":
                return <img src={PayShopIcon} />
            //return <PayShop className={classes.listIcon}  />
            case "driver":
                return <img src={PayDriverIcon} />
            //return <PayDriver className={classes.listIcon}  />
            case "customer":
                return <img src={PartyPaymentIcon} />
            case "fuelcard":
                return <img src={FuelRechargeIcon} width={32} height={32} />
            case "wallet":
                return <PaymentWallet className={classes.listIcon} />
            case "fastag":
                return <PaymentFastag className={classes.listIcon} />
            default:
                return null
        }
    }
    const getTypesAmount = (type) => {
        switch (type) {
            case "vendor":
                return true
            case "shop":
                return true
            case "driver":
                return true
            case "customer":
                return false
            case "fastag":
                return true
            default:
                return false
        }
    }
    const payAgain = (e, data, type) => {
        e.preventDefault();
        e.stopPropagation();
        setDefaultData(data);
        if (type && type == "driver") {
            handlePayDriverOpen(e)
        }
        if (type && type == "shop") {
            handlePayShopOpen(e)
        }
    }
    const handlePayAgain = (data, type) => {
        setOpen(false);
        if (transactionData && transactionData.entityType && transactionData.entityType == "driver") {
            setDefaultData({
                entityId: transactionData && transactionData.driverId ? transactionData.driverId : null,
                entityType: "driver",
                amount: transactionData && transactionData.amount ? transactionData.amount : null
            })
            handlePayDriverOpen()
        }
        if (transactionData && transactionData.entityType && transactionData.entityType == "shop") {
            setDefaultData({
                entityId: transactionData && transactionData.shopId ? transactionData.shopId : null,
                entityType: "shop",
                amount: transactionData && transactionData.amount ? transactionData.amount : null
            })
            handlePayShopOpen()
        }
        setTransactionData(null)
    }
    const getTypesColor = (type) => {
        switch (type) {
            case "vendor":
                return "#ff0000"
            case "shop":
                return "#ff0000"
            case "driver":
                return "#ff0000"
            case "customer":
                return "#379953"
            case "fastag":
                return "#0033cc"
            case "fuelcard":
                return "#0033cc"
            default:
                return "#161f34"
        }
    }
    const getPaymentStatus = (type) => {
        switch (type) {
            case "SUCCESS":
                return <CheckCircleIcon className={classes.completed} />
            case "RELEASED":
                return <CheckCircleIcon className={classes.completed} />
            case "PENDING":
                return <div className={classes.pendingDiv}><TransactionPending className={classes.pendingIcon} /> <span className={classes.pending}></span>Pending</div>
            default:
                return ""
        }
    }
    const saveAsScreenShot = () => {
        /*html2canvas(document.getElementById("payment-details-card")).then(function(canvas) {
            var a = document.createElement('a');
            // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
            a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            a.download = 'somefilename.jpg';
            a.click();
        });*/
    }
    const muiData = transactionHistoryData;
    const muiColumns = [
        {
            name: "transactionId",
            label: " ",
            options: {
                filter: true,
                sort: false,
                /*customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = transactionHistoryData[dataIndex];
                    let type = data && data.entityType ? data.entityType : null;
                    if (rowIndex === transactionHistoryData.length - 10) {
                        return (
                          <Fragment>
                            <Waypoint
                              onEnter={() => {
                                if(user && user.allTransactionHistory && user.allTransactionHistory.maxPage && user.allTransactionHistory.maxPage != currentPageNo){
                                  setCurrentPageNo(currentPageNo+1)
                                  getPaginatedData()
                                }
                              }}
                            />
                            <div className={classes.nameDivIcon}>
                                  <div className={classes.iconDiv}>
                                      {getTypesIcons(type)}
                                  </div>
                              </div>
                          </Fragment>
                        );
                      } else {
                        return (
                            <>
                                <div className={classes.nameDivIcon}>
                                    <div className={classes.iconDiv}>
                                        {getTypesIcons(type)}
                                    </div>
                                </div>
                            </>
                        )
                      }
                }
            },*/
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;
                    let data = findArrayObject("transactionId", value, transactionHistoryData)
                    let type = data && data.entityType ? data.entityType : null;


                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {

                                        if (user && user.allTransactionHistory && user.allTransactionHistory.maxPage && user.allTransactionHistory.maxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div className={classes.nameDivIcon}>
                                    <div className={classes.iconDiv}>
                                        {getTypesIcons(type)}
                                    </div>
                                </div>
                            </Fragment>
                        );
                    } else {
                        return (
                            <Fragment>
                                <div className={classes.nameDivIcon}>
                                    <div className={classes.iconDiv}>
                                        {getTypesIcons(type)}
                                    </div>
                                </div>
                            </Fragment>
                        )
                    }
                }
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = transactionHistoryData[dataIndex];
                    let type = data && data.entityType ? data.entityType : null;
                    return (
                        <>
                            <div className={classes.nameDiv}>
                                <div className={classes.txnName}>
                                    <Typography>
                                        <Highlighter
                                            highlightClassName={classes.highlight}
                                            searchWords={[searchText]}
                                            autoEscape={true}
                                            textToHighlight={data && data.name ? data.name : ""}
                                        />
                                    </Typography>
                                    {type && type == "fastag" ? <><FiberManualRecord className={classes.indicator} /><Typography className={classes.txType}>FASTag Recharge</Typography></> : null}
                                    {type && type == "fuelcard" ? <><FiberManualRecord className={classes.indicator} /><Typography className={classes.txType}>Diesel Card Recharge</Typography></> : null}
                                </div>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "dateDisplay",
            label: "Payment Date",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    return (
                        <div className={classes.fw300}>{value}</div>
                    )
                }
            },
        },
        {
            name: "paymentTitle",
            label: "Payment Method",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = transactionHistoryData[dataIndex];
                    let paymentModes = data && data.paymentModes ? data.paymentModes : null;
                    let paymentMode = data && data.paymentMode ? data.paymentMode : null;
                    return (
                        <GetPaymentModes mode={paymentMode} modes={paymentModes} />
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Amount",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = transactionHistoryData[dataIndex];
                    let type = data && data.entityType ? data.entityType : null;
                    let paymentStatus = data && data.paymentStatus ? data.paymentStatus : null;
                    let paymentTitle = data && data.paymentTitle ? data.paymentTitle : null;
                    let minius = getTypesAmount(type)
                    return (
                        <>
                            <div className={classes.amountDiv}>
                                <div className={classes.statusDiv}>
                                    <div style={{ color: getTypesColor(type) }} className={classes.amountTxt}>
                                        <span>{type && (type != 'fastag') && <>{minius ? '-' : type = 'fuelcard' ? '' : '+'}</>}{numberFormat(data.amount)}</span>
                                    </div>
                                    <div className={classes.statusTxt}>
                                        <GetPaymentStatusIconOnly leftStatusTxt={true} paymentTitle={paymentTitle} type={paymentStatus} />
                                    </div>
                                </div>
                                {/* {paymentStatus && paymentStatus == 'SUCCESS' && <div className={classes.actionDiv}>
                                    {type && (type == "driver" || type == "shop") && <Button onClick={(e) => { payAgain(e, data, type) }} className={classes.payAgain}>Pay Again</Button>}
                                </div>} */}
                            </div>
                        </>
                    )
                }
            },
        }
    ];
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: configInfo && configInfo.supplierPayout && configInfo.supplierPayout.show == 0 && configInfo.driverPayout && configInfo.driverPayout.show == 0 && configInfo.shopPayout && configInfo.shopPayout.show == 0 ? onlinePaymentsTableHeightWithoutTopCards : onlinePaymentsTableHeight,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        pagination: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleTransactionRow(rowMeta.dataIndex);
        },
        customToolbar: (data) => {
            return <>
                {/* <Button variant="contained" classes={{ root: classes.addPartyCta, label: classes.label, }} color="primary" onClick={handleAddPartyClick}>
                    <AddIcon /> Add Vehicle
                </Button>
                <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={goToTrip}>
                    <AddIcon /> Add Trip
                </Button> */}
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search by Name or Amount',
        onSearchChange: (searchText) => {
            setSearchText(searchText ? !searchText.replace(/\s/g, '').length ? searchText.trim() : searchText : "");
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }
            return isFound;
        },
        textLabels: {
            body: {
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handlePopUpPaySupplierOpen = () => {
        setSupplierPaymentOpen(true);
        setOnlinePaymentPopUpOpen(false);
    }

    const handleOnlinePaymentPopUpClose = () => {
        setOnlinePaymentPopUpOpen(false);
    }

    const handleFastTagDetailsClose = () => {
        setFastTagTransactDetailsOpen(false);
    }

    const handleRechargeFastagOpen = (e, data) => {
        dispatchGetSingleFastTagDetails(
            transactionData.vehicleId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Online payments dweb", "Get single fastag details successfull");
                    setDefaultData({
                        id: transactionData && transactionData.vehicleId ? transactionData.vehicleId : "",
                        vehicleId: transactionData && transactionData.vehicleId ? transactionData.vehicleId : "",
                        amount: data && data.rechargeAmount ? data.rechargeAmount : null
                    })
                    setFastTagTransactDetailsOpen(false);
                    setRechargeFastagOpen(true);
                }
            },
            () => {
                logger.log("Online payments dweb", "Get single fastag details failed");
            }
        )
    }

    const handleRechargeFastagClose = (entityData) => {
        setDefaultData(null);
        setRechargeFastagOpen(false);
        setFastTagTransactDetailsOpen(false);
        setRecall(!recall);
        setCurrentPageNo(1);
    }

    const handleCloseTransactionReport = () => {
        setTransactionReportOpen(false);
    }

    const handleTransactionReport = () => {
        setTransactionReportOpen(true);
    }

    const handleRedirectionToDiesel = () => {
        history.push({
            pathname: '/diesel-card',
            state: {
                id: 1,
                pageTitle: 'Diesel Card'
            }
        })
    }

    return (
        <div className={classes.mtV10}>
            <Wrapper>
                <Paper className={classes.pageContentDIv} elevation={3}>
                    {/* <Grid container direction="row" spacing={2} >
                        {configInfo && configInfo.supplierPayout && configInfo.supplierPayout.show == 1 &&
                            <Grid item xs={12} sm={6} md={4} onClick={(e) => { handlePaySupplierOpen(e) }}>
                                <TopCardIcon title='Pay Supplier' icon={<PaySupplier />} infoText='Transfer money online to your Supplier' />
                            </Grid>
                        }
                        {configInfo && configInfo.driverPayout && configInfo.driverPayout.show == 1 &&
                            <Grid item xs={12} sm={6} md={4} onClick={(e) => { handlePayDriverOpen(e) }}>
                                <TopCardIcon title='Pay Driver' icon={<PayDriver />} infoText='Transfer money online to your Driver' />
                            </Grid>
                        }
                        {configInfo && configInfo.shopPayout && configInfo.shopPayout.show == 1 &&
                            <Grid item xs={12} sm={6} md={4} onClick={(e) => { handlePayShopOpen(e) }}>
                                <TopCardIcon title='Pay Shop' icon={<PayShop />} infoText='Transfer money online to your Petrol Bunk, Service Center, Tyre Shop ' comingSoon={false} />
                            </Grid>
                        }
                    </Grid> */}
                    {/* <div className={configInfo && configInfo.supplierPayout && configInfo.supplierPayout.show == 0 && configInfo.driverPayout && configInfo.driverPayout.show == 0 && configInfo.shopPayout && configInfo.shopPayout.show == 0 ? classes.tableDivV1 : classes.tableDivV1}> */}
                    <div className={classes.tableDivOnlinePayments}>
                        <div className={classes.tableToolBar}>
                            <div className={classes.tableTitle}>
                                <TransactionHistory className={classes.tableTitleIcon} />
                                <Typography className={classes.title}>Transaction History</Typography>
                            </div>
                            {initialEmpty ? <></> : <div className={classes.toolBarFilter}>
                                <div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon className={classes.sicon} />
                                    </div>
                                    {/* <div className={classes.closeIcon} onClick={(e)=>{}}>
                            <CloseIcon className={classes.sicon}   />
                        </div> */}
                                    <InputBase
                                        placeholder="Search for Names or Amount"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        onBlur={(e) => {
                                            //onSearchBlur(e)
                                        }}
                                        type="text"
                                        //value={searchText}
                                        onChange={(e) => {
                                            let query = e.target.value;
                                            if (e && e.target && e.target.value && e.target.value.length > 1) {
                                                setSearchText(e.target.value)
                                                onSearchBlur(query)
                                            } else if (searchText && e.target && e.target.value && e.target.value.trim().length <= 1) {
                                                setSearchText("");
                                                onSearchBlur("")
                                            }
                                        }}
                                        inputProps={{ 'aria-label': 'search' }}
                                    />
                                </div>
                                <div className={classes.selectionFilter}>
                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <DateFilter fromTripListing={true} dateValue={handleDateValue} roundedBorder={true} />
                                        </div>
                                        <div style={{ marginLeft: 24 }}>
                                            <PaymentStatusFIlter roundedBorder={true} fromTripListing={true} status={handlePaymentStatusValue} defaultTripStatusFilter={selectedFilterStatus} />
                                        </div>
                                    </div>
                                    <div>
                                        <Button variant="contained" classes={{ root: classes.viewPDFCta, label: classes.label, }} color="primary" onClick={() => { handleTransactionReport() }}>
                                            <PictureAsPdfIcon />&nbsp;View PDF
                                        </Button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                        {initialEmpty ? <div className={classes.emptyStateDiv}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/empty_online.png`} alt="Empty State Image" />
                            <Typography className={classes.emptyTxt}>All Online Payments made through TransportBook will be shown here</Typography>
                        </div> : <MUIDataTable title={""} className={classes.onlinePaymentsTable} data={muiData} columns={muiColumns} options={options} />}
                    </div>
                </Paper>
                {driverPaymentOpen && <PayDriverSideBar
                    rightSideBarOpen={driverPaymentOpen}
                    defaultData={defaultData}
                    sideBarTitle={'Driver Payment'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handlePayDriverClose}
                ><div></div></PayDriverSideBar>}
                {transactionReportOpen && <TransactionReportDialog open={transactionReportOpen} name={'Transaction Report'} onClose={handleCloseTransactionReport}
                    defaultValueObject={
                        {
                            paymentStatusFilter: selectedFilterStatus,
                            dateFilterStatus: selectedFilterDate,
                            customDateRange: customFilterValue
                        }
                    } />}
                {supplierPaymentOpen &&
                    <PaySupplierSideBar
                        sideBarTitle="pay-supplier-details-side-bar"
                        rightSideBarOpen={supplierPaymentOpen}
                        toggleRightSideBar={handlePaySupplierClose}
                        calledFromFlow={"onlinePayments"}
                    >
                    </PaySupplierSideBar>
                }
                {shopPaymentOpen && <PayShopSideBar
                    rightSideBarOpen={shopPaymentOpen}
                    defaultData={defaultData}
                    sideBarTitle={'Shop Payment'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handlePayShopClose}
                ><div></div></PayShopSideBar>}

                {open && <TransactionDetailsSideBar
                    rightSideBarOpen={open}
                    sideBarTitle={'Transaction Details'}
                    sideBarSecondaryTitle={secondaryTitle}
                    transData={transactionData && transactionData.entityType &&
                        (transactionData.entityType == 'wallet' || transactionData.entityType == 'vendor' || transactionData.entityType == 'fuelcard' || transactionData.entityType == 'customer')
                        ? null : transactionData}
                    payAgain={handlePayAgain}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleClose}
                >
                    <div id="payment-details-card" onClick={() => { saveAsScreenShot() }}>
                        <SingleOnlineTransactionDetailsCard
                            data={transactionData}
                            type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                        />
                        {(transactionData && (transactionData.tripDetails && transactionData.tripDetails.length > 0 || transactionData.tripId)) && <><DottedDivider />
                            <TripListingCard
                                data={transactionData}
                                type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                            /></>}
                    </div>
                </TransactionDetailsSideBar>}

                {fastTagTransactDetailsOpen &&
                    <FastTagTransactDetailsSideBar rightSideBarOpen={fastTagTransactDetailsOpen} toggleRightSideBar={handleFastTagDetailsClose} rechargeAgain={handleRechargeFastagOpen} />
                }

                {/* {rechargeFastagOpen && <RechargeFastagSideBar
                    rightSideBarOpen={rechargeFastagOpen}
                    defaultData={defaultData}
                    sideBarTitle={'Recharge FASTag'}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleRechargeFastagClose}
                ><div></div></RechargeFastagSideBar>} */}

                {successCreation && <SuccessDialog open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
                {failureCreation && <FailureDialog open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            </Wrapper>

            {/* {onlinePaymentPopUpOpen && <OnlinePaymentsPopUp open={onlinePaymentPopUpOpen} onClose={handleOnlinePaymentPopUpClose} onAddSupplierPayment={handlePopUpPaySupplierOpen} />} */}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </div>
    );
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetPaymentDetails: (data, onSuccess, onError) => {
        dispatch(getSinglePayment(data, onSuccess, onError))
    },
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchTransactionHistoryAction: (requestData, onSuccess, onError) => {
        dispatch(
            getTransactionHistory(
                requestData,
                (data) => {
                    trackDwebEvent('Dweb Online Payment Page', {})
                    if (onSuccess) {
                        onSuccess(data);
                    }
                },
                (data) => {
                    if (onError) {
                        onError(onError);
                    }
                }
            )
        )
    },
    dispatchGetFastTagRechargeStatus: (transactionId, onSuccess, onFailure) => {
        dispatch(getFastTagRechargeStatus(transactionId, onSuccess, onFailure))
    },
    dispatchGetSingleFastTagDetails: (fastTagId, onSuccess, onError) => {
        dispatch(getSingleFastTagDetails(fastTagId, onSuccess, onError))
    }
});
const OnlinePaymentsWithRouter = withRouter(OnlinePayments);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OnlinePaymentsWithRouter);
